import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

import { addErrorNotification } from "../../notifications/actions"
import { userMenuAPI } from "../../../apis"
import { IUserFormattingSettings } from "../../applicationheader/components/usermenu"
import { Settings } from "luxon"

const defaultState: IUserFormattingSettings = {
    shortDatePattern: "dd/MM/yyyy",
    shortTimeFormat: "hh:mm",
    numberFormat: {
        decimalDigits: 3,
        decimalSeparator: ".",
        groupSeparator: ",",
        groupSizes: [3],
    },
    timeZone: null,
    isInitialized: false,
}

export const userFormattingSettingsSlice = createSlice({
    name: "fields",

    initialState: defaultState,

    reducers: {},

    extraReducers: (builder) => {
        builder.addCase(fetchFormattingSettings.fulfilled, (state, action) => {
            return action.payload as IUserFormattingSettings
        })
    },
})

export default userFormattingSettingsSlice.reducer

export const fetchFormattingSettings = createAsyncThunk(
    "fields/fetchFormattingSettings",
    async (_, { dispatch }) => {
        let settings: IUserFormattingSettings = defaultState
        try {
            settings = await userMenuAPI.getUserFormattingSettings()
            const offsetRegex = /\(([^)]+)\)/
            Settings.defaultZone =
                settings?.timeZone?.label?.match(offsetRegex)?.[1] ?? "system"
        } catch (error) {
            dispatch(addErrorNotification(defaultFetchUserSettingsError))
        }
        return settings
    },
)

export const defaultFetchUserSettingsError = "Cannot fetch user settings"
